import TextField, {TextFieldProps} from '@material-ui/core/TextField'
import {useEvent} from 'Event/EventProvider'
import {onChangeStringHandler} from 'lib/dom'
import React from 'react'
import {ZapierTag} from 'Event/zapier'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'

export default function ZapierTagInput(
  props: Omit<TextFieldProps, 'value' | 'onChange' | 'label'> & {
    onChange: (tag: ZapierTag | null) => void
    value?: ZapierTag | null
    inputVariant?: 'filled' | 'standard' | 'outlined'
    label?: string
  },
) {
  const {
    disabled,
    value,
    onChange,
    label,
    inputVariant,
    ...textFieldProps
  } = props
  const {event} = useEvent()

  const name = value?.name || ''

  if (!event.has_zapier) {
    return null
  }

  return (
    <IntegrationTagField>
      <TextField
        value={name}
        variant={inputVariant ?? 'outlined'}
        label={label ?? 'Zapier Tag'}
        fullWidth
        inputProps={{
          'aria-label': 'zapier tag',
        }}
        onChange={onChangeStringHandler((name) => onChange({name}))}
        disabled={disabled}
        {...textFieldProps}
      />
    </IntegrationTagField>
  )
}
